import './index.less';
import { CaretDownFilled, CaretRightFilled, CaretUpFilled, CaretLeftFilled } from '@ant-design/icons';
import { ReactComponent as PanSvg } from '@/commons/icons/view-tool/pan.svg'
import { ReactComponent as RotateSvg } from '@/commons/icons/view-tool/rotate.svg'
import { ReactComponent as ZoomInSvg } from '@/commons/icons/view-tool/zoom-in.svg'
import { ReactComponent as ZoomOutSvg } from '@/commons/icons/view-tool/zoom-out.svg'
import { ReactComponent as ZoomAllSvg } from '@/commons/icons/view-tool/zoom-all.svg'
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { graphicStore } from '@/commons/store/graphic-store';
import { Camera, Clock, OrthographicCamera, PerspectiveCamera, WebGLRenderer } from 'three';
import { DefaultMouseControl, ViewCube, ViewEditor } from 'pytha';
import classNames from 'classnames';
import { EXTRA_SUB_CONTROL } from '@/commons/enums/extra-sub-controls';
import { EXTRA_SINGAL } from '@/commons/enums/extra-singal';
import { BIM_SINGAL, BIM_BASE_EXTRA_SUB_CONTROL_COMMON, BUILDING_SUB_CONTROL, BUILDING_SINGAL } from 'tnbimbase';
import { STRUCTURE_SUB_CONTROL } from '@/passets/structure-engine/enums/structure-sub-control';
import { STRUCTURE_SIGNAL } from '@/passets/structure-engine/enums/structure-signal';
import { HVAC_SIGNAL } from '@/passets/hvac-engine/enums/hvac-signal';
import { HVAC_SUB_CONTROL } from '@/passets/hvac-engine/enums/hvac-sub-control';
import { ARCHI_SUB_CONTROL } from '@/passets/archibase-engine/enums/archi-sub-control';
import { ARCHIBASE_SINGAL } from '@/passets/archibase-engine/enums/archibase-singal';
import { DEVICE_SUB_CONTROL } from '@/passets/devicebase-engine/enums/device-sub-controls';
import { DEVICEBASE_SINGAL } from '@/passets/devicebase-engine/enums/devicebase-singal';
import { PYTHA_SINGAL } from '@/passets/pytha-engine/enums/pytha-signal';
import { ModelsInDevice } from '@/passets/devicebase-engine/models';
import { PYTHA_SUB_CONTROL } from '@/passets/pytha-engine/enums/pytha-sub-controls';

const _clock = new Clock();


export enum CAMERA_TYPE {
    Orthographic,
    Perspective
}

interface Iprops {
    sceneUpdate: string,
    viewportId: string,
    viewHelperId: string,
    cameraType?: number,  //默认为正交相机
}

export default function Viewport(props: Iprops) {
    const { projectUuid } = useParams();
    const viewportId = props.viewportId;
    const viewHelperId = props.viewHelperId;
    const viewCube = useRef<ViewCube>();
    const stats = useRef<Stats>();
    const [activeTool, setActiveTool] = useState<number>(0)

    // const onSelect= (entities: ModelBase) => {
    //     console.log("entities", entities);
    // }

    useEffect(() => {
        if (projectUuid == null || graphicStore.extraContext == null || !graphicStore.extraContext.sceneContext.scene) return () => { };
        let editor = new ViewEditor(graphicStore.extraContext.listeners, projectUuid, viewportId);
        graphicStore.extraContext.addViewEditor(viewportId, editor);
        // editor.listeners.signals.onSelectChanged.add(onSelect);


        const renderer = createRenderer();
        editor.renderer = renderer;

        const camera = createCamera(graphicStore.context.renderContext.cameraEdge, props.cameraType ? props.cameraType : CAMERA_TYPE.Orthographic);
        editor.camera = camera;

        const viewControl = initControls(editor, renderer, camera);

        //注册二级控制器
        Object.keys(EXTRA_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: EXTRA_SUB_CONTROL[key].name,
                cmd: EXTRA_SUB_CONTROL[key].cmd,
                needInit: EXTRA_SUB_CONTROL[key]?.needInit,
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(EXTRA_SUB_CONTROL[key].cmd, EXTRA_SUB_CONTROL[key].clazz);
        })
        Object.keys(STRUCTURE_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: STRUCTURE_SUB_CONTROL[key].name,
                cmd: STRUCTURE_SUB_CONTROL[key].cmd,
                needInit: STRUCTURE_SUB_CONTROL[key]?.needInit,
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(STRUCTURE_SUB_CONTROL[key].cmd, STRUCTURE_SUB_CONTROL[key].clazz);
        })
        Object.keys(HVAC_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: HVAC_SUB_CONTROL[key].name,
                cmd: HVAC_SUB_CONTROL[key].cmd,
                needInit: HVAC_SUB_CONTROL[key]?.needInit,
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(HVAC_SUB_CONTROL[key].cmd, HVAC_SUB_CONTROL[key].clazz);
        })
        Object.keys(BUILDING_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: BUILDING_SUB_CONTROL[key].name,
                cmd: BUILDING_SUB_CONTROL[key].cmd,
                needInit: BUILDING_SUB_CONTROL[key]?.needInit,
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(BUILDING_SUB_CONTROL[key].cmd, BUILDING_SUB_CONTROL[key].clazz);
        })
        Object.keys(BIM_BASE_EXTRA_SUB_CONTROL_COMMON).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: BIM_BASE_EXTRA_SUB_CONTROL_COMMON[key].name,
                cmd: BIM_BASE_EXTRA_SUB_CONTROL_COMMON[key].cmd,
                needInit: BIM_BASE_EXTRA_SUB_CONTROL_COMMON[key]?.needInit,
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(BIM_BASE_EXTRA_SUB_CONTROL_COMMON[key].cmd, BIM_BASE_EXTRA_SUB_CONTROL_COMMON[key].clazz);
        })
        //注册额外二级控制器
        Object.keys(ARCHI_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: ARCHI_SUB_CONTROL[key].name,
                cmd: ARCHI_SUB_CONTROL[key].cmd,
                needInit: ARCHI_SUB_CONTROL[key]?.needInit,
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(ARCHI_SUB_CONTROL[key].cmd, ARCHI_SUB_CONTROL[key].clazz);
        })
        Object.keys(DEVICE_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: DEVICE_SUB_CONTROL[key].name,
                cmd: DEVICE_SUB_CONTROL[key].cmd,
                needInit: DEVICE_SUB_CONTROL[key]?.needInit
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(DEVICE_SUB_CONTROL[key].cmd, DEVICE_SUB_CONTROL[key].clazz);
        })
        Object.keys(PYTHA_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: PYTHA_SUB_CONTROL[key].name,
                cmd: PYTHA_SUB_CONTROL[key].cmd,
                needInit: PYTHA_SUB_CONTROL[key]?.needInit
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(PYTHA_SUB_CONTROL[key].cmd, PYTHA_SUB_CONTROL[key].clazz);
        })
        // 此处注册额外信号和额外的二级控制器
        if (graphicStore?.context) {
            Object.keys(ModelsInDevice).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInDevice[type]);
            })
        }


        Object.keys(DEVICEBASE_SINGAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(DEVICEBASE_SINGAL[key]);
        })

        Object.keys(PYTHA_SINGAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(PYTHA_SINGAL[key]);
        })
        //注册额外信号
        Object.keys(EXTRA_SINGAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(EXTRA_SINGAL[key]);
        })
        Object.keys(BIM_SINGAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(BIM_SINGAL[key]);
        })
        Object.keys(BUILDING_SINGAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(BUILDING_SINGAL[key]);
        })
        Object.keys(STRUCTURE_SIGNAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(STRUCTURE_SIGNAL[key]);
        })
        Object.keys(HVAC_SIGNAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(HVAC_SIGNAL[key]);
        })
        //注册额外信号
        Object.keys(ARCHIBASE_SINGAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(ARCHIBASE_SINGAL[key]);
        })

        viewCube.current = createViewCube(camera, viewControl);
        editor.viewCube = viewCube.current;

        graphicStore.extraContext.setCurrentViewportId(viewportId);

        render();

        return (() => {
            if (!!editor) {
                if (!!viewCube?.current) {
                    viewCube?.current.dispose();
                }
                // editor.listeners.signals.onSelectChanged.remove(onSelect);
                editor.renderer.domElement.parentElement.removeChild(editor.renderer.domElement);
                editor.renderer.setAnimationLoop(null);
                editor.renderer.forceContextLoss()
                editor.dispose();
                if (graphicStore.extraContext && graphicStore.extraContext.sceneContext
                    && graphicStore.extraContext.sceneContext.scene) {
                    graphicStore.extraContext.sceneContext.scene.clear();
                    graphicStore.extraContext.sceneContext.scene = null;
                }
            }
            graphicStore.extraContext?.deleteViewEditor(viewportId);
        })

    }, [projectUuid, graphicStore.extraContext, props.sceneUpdate])

    useEffect(() => {
        const editor = graphicStore.extraContext.getViewEditor(viewportId);
        if (!editor) return;
        changeCameraType(props.cameraType, editor);
        switch (props.cameraType) {
            case CAMERA_TYPE.Orthographic:
                // editor.changeCameraType("OrthographicCamera");
                viewCube.current.camera = editor.camera;
                graphicStore.extraContext.listeners.signals.needRender.dispatch();
                // // 开启夹点显示
                editor.clampControl.enabled = true;
                editor.clampControl.hidden = false;
                // 显示旋转球
                editor.viewControl.needRotateHelper = true;
                // 渲染光标
                editor.cursorControl.needRenderCursor = true;
                // 激活选择
                editor.selectControl.setEnabled(true);
                // 添加坐标系
                let currentUcs = graphicStore.context.ucsContext.currentUcs;
                currentUcs = currentUcs.clone();
                let viewObj = currentUcs.render();
                if (!!viewObj) {
                    graphicStore.extraContext.sceneContext.scene?.add(viewObj);
                }
                // graphicStore.extraContext.getCurrentViewEditor()?.showAllEntities(true);
                graphicStore.extraContext.listeners.signals.needRender.dispatch();
                break;
            case CAMERA_TYPE.Perspective:
                // editor.changeCameraType("PerspectiveCamera");
                viewCube.current.camera = editor.camera;
                // 关掉夹点显示
                editor.clampControl.enabled = false;
                editor.clampControl.hidden = true;
                // 不渲染光标
                editor.cursorControl.needRenderCursor = false;
                //不显示旋转球
                editor.viewControl.needRotateHelper = false;
                // 钝化选择
                editor.selectControl.setEnabled(false);
                // 删除坐标系
                let oldUcs = graphicStore.context.ucsContext.currentUcs;
                if (!!oldUcs && oldUcs.viewObj && oldUcs.viewObj.parent) {
                    // 遍历 viewObj 及其子对象，设置透明度
                    oldUcs.viewObj.parent.remove(oldUcs.viewObj);
                }
                graphicStore.extraContext.getCurrentViewEditor()?.showAllEntities(true);
                graphicStore.extraContext.listeners.signals.needRender.dispatch();
                break;
        }
    }, [props.cameraType])

    /**
     * 修改相机类型
     * @param 相机转化至的类型
     */
    const changeCameraType = (type, editor) => {
        if (type === CAMERA_TYPE.Orthographic) {
            if (editor.orthoCamera != null) {
                editor.camera = editor.orthoCamera;
            } else {
                editor.camera = createCamera(graphicStore.context.renderContext.cameraEdge, type);
                editor.orthoCamera = editor.camera;
            }
        } else if (type === CAMERA_TYPE.Perspective) {
            if (editor.perspCamera != null) {
                editor.camera = editor.perspCamera;
            } else {
                editor.camera = createCamera(graphicStore.context.renderContext.cameraEdge, type);
                editor.perspCamera = editor.camera;
            }
        }
    }

    useEffect(() => {
        if (!graphicStore.extraContext) return () => { };
        graphicStore.extraContext.listeners.signals.windowResize.add(onWindowResize);
        graphicStore.extraContext.listeners.signals.needRender.add(render);
        graphicStore.extraContext.listeners.signals.onViewCubeWorking.add(onViewCubeWorking);
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.add(reSetToolBar);
        return (() => {
            if (!graphicStore.extraContext) return;
            graphicStore.extraContext.listeners.signals.windowResize.remove(onWindowResize);
            graphicStore.extraContext.listeners.signals.needRender.remove(render);
            graphicStore.extraContext.listeners.signals.onViewCubeWorking.remove(onViewCubeWorking);
            graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.remove(reSetToolBar);
        })
    }, [projectUuid, graphicStore.extraContext, viewCube])

    useEffect(() => {
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        const renderer = viewEditor?.renderer;
        if (!!renderer) {
            renderer.setAnimationLoop(animate);
        }
    }, [viewCube])

    const onWindowResize = (offset: number = 0) => {
        const root = document.getElementById(viewportId);
        if (!root) return;
        const aspect = root.offsetWidth / root.offsetHeight;
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        if (viewEditor == null) return;
        if (!viewEditor.camera) return;
        if (viewEditor.camera.type === 'OrthographicCamera') {
            let camera = viewEditor.camera as OrthographicCamera;


            camera.left = camera.bottom * aspect;
            camera.right = camera.top * aspect;
            camera.updateProjectionMatrix();

        } else if (viewEditor.camera.type === 'PerspectiveCamera') {
            let camera = viewEditor.camera as PerspectiveCamera;
            camera.aspect = aspect;
            camera.updateProjectionMatrix();
        }
        let renderer = viewEditor.renderer;
        renderer.setSize(root.offsetWidth - offset, root.offsetHeight);
        renderer.setViewport(0, 0, root.offsetWidth - offset, root.offsetHeight)
        viewCube?.current?.updateSize();
        render();
    }

    const onViewCubeWorking = (value) => {
        if (!value) {
            const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
            const domElement = viewEditor.renderer?.domElement;
            domElement?.focus();
        }
    }

    const createRenderer = () => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        root.oncontextmenu = (e) => {
            e.preventDefault();
        }
        const renderer = new WebGLRenderer({
            antialias: true,
            logarithmicDepthBuffer: true
        });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(root.offsetWidth, root.offsetHeight);
        renderer.setClearColor('#f5f5f5', 1.0);
        renderer.autoClear = false;
        renderer.setAnimationLoop(animate);
        root.appendChild(renderer.domElement);
        renderer.domElement.setAttribute('tabindex', '1');
        renderer.domElement.style.outline = '0px';
        return renderer;
    }

    const reSetToolBar = () => {
        setActiveTool(0)
    }

    const animate = () => {
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        if (viewEditor == null) return;

        let delta = _clock.getDelta();
        let needsUpdate = false;
        if (viewCube?.current && viewCube.current?.animating) {
            viewCube?.current.update(delta);
            needsUpdate = true;
        }
        if (needsUpdate) {
            render();
        }
        if (stats?.current) {
            stats.current.update();
        }
    }

    const createCamera = (s = 30, cameraType = CAMERA_TYPE.Orthographic) => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (cameraType === CAMERA_TYPE.Orthographic) {
            const camera = new OrthographicCamera(-s * aspect, s * aspect, s, -s, 0, 1e7);
            camera.position.set(0, 0, 1e7 / 2)
            camera.lookAt(0, 0, 0)
            return camera;
        } else if (cameraType === CAMERA_TYPE.Perspective) {
            const fov = 75;
            const camera = new PerspectiveCamera(fov, aspect, 0.1, 1e7);
            camera.position.set(0, 0, 300000)
            camera.lookAt(0, 0, 0)
            return camera;
        }
        return null;
    }

    const initControls = (editor: ViewEditor, renderer: WebGLRenderer, camera: Camera) => {
        editor.camera = camera;
        editor.renderer = renderer;
        let viewControl = editor.initControl();
        return viewControl;
    }

    const createViewCube = (camera: Camera, viewControl: DefaultMouseControl) => {
        let viewCube = new ViewCube(camera, viewHelperId, graphicStore.extraContext.listeners);
        viewCube.controls = viewControl;
        viewCube.listeners = graphicStore.extraContext.listeners;
        return viewCube;
    }

    const render = (arg: string = null) => {
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        if (!viewEditor) {
            return;
        }
        let renderer = viewEditor.renderer;
        let camera = viewEditor.camera;
        if (!renderer) return;
        const root = document.getElementById(viewportId);
        if (!root) return;
        renderer.setViewport(0, 0, root.offsetWidth, root.offsetHeight)
        renderer.clear();
        if (arg === 'redraw') {
            viewEditor.renderControl.render();
        } else if (arg === 'position') {
            viewEditor.renderControl.render();
        } else if (arg === 'color') {
            viewEditor.renderControl.render();
        }
        if (!graphicStore.extraContext.sceneContext.scene) return;
        renderer.render(graphicStore.extraContext.sceneContext.scene, camera);
        if (!!viewCube?.current) {
            viewCube?.current.render(renderer);
        }
    }


    return (
        <div id={viewportId} className="viewport"
            onClick={() => {
                if (viewportId !== graphicStore.extraContext.getCurrentViewportId()) {
                    graphicStore.extraContext.setCurrentViewportId(viewportId);
                }
            }}
            onMouseEnter={() => {
                if (viewportId == graphicStore.extraContext.getCurrentViewportId()) {
                    graphicStore.extraContext.getCurrentViewEditor()?.renderer.domElement.focus();
                }
            }}
        >
            <div id={viewHelperId} className="view-helper" >
                <div id={viewHelperId + '_top'} className="top arrow">
                    <CaretDownFilled className="arrow-icon" />
                </div>
                <div id={viewHelperId + '_left'} className="left arrow">
                    <CaretRightFilled className="arrow-icon" />
                </div>
                <div id={viewHelperId + '_down'} className="down arrow">
                    <CaretUpFilled className="arrow-icon" />
                </div>
                <div id={viewHelperId + '_right'} className="right arrow">
                    <CaretLeftFilled className="arrow-icon" />
                </div>
            </div>
            <div className="toolbar">
                <div className={classNames({
                    'tool-btn': true,
                    'is-active': activeTool == 1
                })} onClick={() => {
                    setActiveTool(1)
                    // systemContext.setNoteVisible(false);
                    graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('P');
                }}>
                    <PanSvg />
                </div>
                <div className={classNames({
                    'tool-btn': true,
                    'is-active': activeTool == 2
                })} onClick={() => {
                    setActiveTool(2)
                    // systemContext.setNoteVisible(false);
                    graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('3DO');
                }}>
                    <RotateSvg />
                </div>
                <div className='tool-btn' onClick={() => {
                    // systemContext.setNoteVisible(false);
                    graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('ZI');
                }}>
                    <ZoomInSvg />
                </div>
                <div className='tool-btn' onClick={() => {
                    // systemContext.setNoteVisible(false);
                    graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('ZO');
                }}>
                    <ZoomOutSvg />
                </div>
                <div className='tool-btn' onClick={() => {
                    // systemContext.setNoteVisible(false);
                    graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('ZA');
                }}>
                    <ZoomAllSvg />
                </div>
            </div>
        </div>
    )
}